import useSWR from "swr";
import { fetcher } from "../lib/api";
import type { TicksResponse } from "../types/api";

// Explicit limit so the calendar always sees the full backfilled year(s).
// Backend default rose from 30 → 1000, but be defensive about future caps.
export function useTicks() {
  const { data, error, isLoading } = useSWR<TicksResponse>("/ticks?limit=2000", fetcher);
  return { ticks: data?.ticks ?? [], isLoading, error };
}
